import { useCallback, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { httpClient } from '../api/http';
import { InterestHistoryItem } from '../types';

const useInterestHistory = () => {
  const params = useParams();
  const userIdIn = params.id as string;

  const LIMIT = 10;

  const [state, setState] = useState<{
    list: InterestHistoryItem[];
    page: number;
    hasMore: boolean;
  }>({ list: [], page: 0, hasMore: true });
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isLoadingMore, setIsLoadingMore] = useState<boolean>(false);

  const fetchPage = useCallback(
    async (page: number, append: boolean) => {
      if (!userIdIn) return;
      try {
        if (append) setIsLoadingMore(true);
        else setIsLoading(true);

        const res = await httpClient.get(`admin/user/interest-toggle-history/${userIdIn}/${page}/${LIMIT}`);
        const data = res.data?.data;
        const incoming: InterestHistoryItem[] = Array.isArray(data?.toggleHistory)
          ? data.toggleHistory
          : Array.isArray(data?.results)
            ? data.results
            : Array.isArray(data)
              ? data
              : [];

        setState((prev) => ({
          list: append ? [...prev.list, ...incoming] : incoming,
          page,
          hasMore: incoming.length === LIMIT,
        }));
      } catch (error) {
        console.error(error);
      } finally {
        setIsLoading(false);
        setIsLoadingMore(false);
      }
    },
    [userIdIn],
  );

  useEffect(() => {
    if (userIdIn) fetchPage(1, false);
  }, [userIdIn, fetchPage]);

  const loadMore = () => {
    if (state.hasMore && !isLoadingMore) fetchPage(state.page + 1, true);
  };

  const refetch = () => fetchPage(1, false);

  return {
    history: state.list,
    hasMore: state.hasMore,
    isLoading,
    isLoadingMore,
    loadMore,
    refetch,
  };
};

export default useInterestHistory;
